import { render } from "./CoPut.vue?vue&type=template&id=add49910&scoped=true"
import script from "./CoPut.vue?vue&type=script&lang=js"
export * from "./CoPut.vue?vue&type=script&lang=js"

import "./CoPut.vue?vue&type=style&index=0&id=add49910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add49910"]])

export default __exports__